<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'complex-table-1';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.complex-table-1 {
  td {
    border-left: $border;
    border-bottom: $border;
    &:last-child {
      border-right: $border;
    }
  }
  th {
    &:not(.empty) {
      border-top: $border;
      border-left: $border;
    }
    &:last-child {
      border-right: $border;
    }
    &:first-child {
      border-left: $border;
    }
  }
  thead {
    tr {
      &:first-child {
        th {
          border-top: $border;
        }
      }
    }
  }
  tbody {
    tr {
      &:first-child {
        border-top: 3px solid var(--theme-color-1);
      }
      &:last-child {
        border-bottom: 3px solid var(--theme-color-1);
      }
    }
  }
}
</style>
